import React from 'react';

const CommonDateSelectionForm = ({
  onSubmitHandler,
  loading,
  btnText,
}) => {
  return (
    <form onSubmit={onSubmitHandler} className="space-y-3">
      <div>
        <label>From</label>
        <input
          name="fromDate"
          type="datetime-local"
          className="w-full p-2 border rounded"
        />
      </div>

      <div>
        <label>To</label>
        <input
          name="toDate"
          type="datetime-local"
          className="w-full p-2 border rounded"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="bg-teal-600 text-white px-4 py-2 rounded">
        {loading ? "Loading..." : btnText}
      </button>
    </form>
  );
};

export default CommonDateSelectionForm;
